module.exports = __webpack_public_path__ + "static/media/image-gallery-6.4c2f5f68.jpg";